import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMultipleCrossCancel = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 17,
	height: 17,
	viewBox: "0 0 17 17",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M0 8.45833C0 3.78692 3.78692 0 8.45833 0C13.1297 0 16.9167 3.78692 16.9167 8.45833C16.9167 13.1297 13.1297 16.9167 8.45833 16.9167C3.78692 16.9167 0 13.1297 0 8.45833ZM6.4643 5.28579C6.13886 4.96035 5.61122 4.96035 5.28579 5.28579C4.96035 5.61122 4.96035 6.13886 5.28579 6.4643L7.27986 8.45837L5.28579 10.4525C4.96035 10.7779 4.96035 11.3055 5.28579 11.631C5.61122 11.9564 6.13886 11.9564 6.4643 11.631L8.45837 9.63689L10.4525 11.631C10.7779 11.9564 11.3055 11.9564 11.631 11.631C11.9564 11.3055 11.9564 10.7779 11.631 10.4525L9.63689 8.45837L11.631 6.4643C11.9564 6.13886 11.9564 5.61122 11.631 5.28579C11.3055 4.96035 10.7779 4.96035 10.4525 5.28579L8.45837 7.27986L6.4643 5.28579Z",
		fill: "#A1A1AA"
	})
});
const ForwardRef = forwardRef(SvgMultipleCrossCancel);
export default ForwardRef;
